// Central registry of supported languages for the panel.
// Keep this in sync with:
//   - the locale JSON files in client/src/i18n/locales/
//   - crowdin.yml target languages
// The `crowdin` field is Crowdin's locale code (used by the CLI mapping).
// `country` is the ISO 3166-1 alpha-2 code used to render a real flag image
// (Windows/Chrome don't render flag emoji, so we use flag images instead).
export const LANGUAGES = [
  { code: 'en',    crowdin: 'en',    country: 'gb', label: 'English',              nativeLabel: 'English' },
  { code: 'pt-BR', crowdin: 'pt-BR', country: 'br', label: 'Portuguese (Brazil)',  nativeLabel: 'Português' },
  { code: 'ru',    crowdin: 'ru',    country: 'ru', label: 'Russian',              nativeLabel: 'Русский' },
  { code: 'zh-CN', crowdin: 'zh-CN', country: 'cn', label: 'Chinese (Simplified)', nativeLabel: '简体中文' },
  { code: 'tr',    crowdin: 'tr',    country: 'tr', label: 'Turkish',              nativeLabel: 'Türkçe' },
  { code: 'pl',    crowdin: 'pl',    country: 'pl', label: 'Polish',               nativeLabel: 'Polski' },
  { code: 'de',    crowdin: 'de',    country: 'de', label: 'German',               nativeLabel: 'Deutsch' },
  { code: 'fr',    crowdin: 'fr',    country: 'fr', label: 'French',               nativeLabel: 'Français' },
  { code: 'uk',    crowdin: 'uk',    country: 'ua', label: 'Ukrainian',            nativeLabel: 'Українська' },
  { code: 'ja',    crowdin: 'ja',    country: 'jp', label: 'Japanese',             nativeLabel: '日本語' },
  { code: 'ro',    crowdin: 'ro',    country: 'ro', label: 'Romanian',             nativeLabel: 'Română' },
  { code: 'is',    crowdin: 'is',    country: 'is', label: 'Icelandic',            nativeLabel: 'Íslenska' },
  { code: 'hi',    crowdin: 'hi',    country: 'in', label: 'Hindi',                nativeLabel: 'हिन्दी' },
];

// Flag image URL for a language's country (flagcdn serves clean flag PNGs).
export function flagUrl(country, size = 40) {
  return `https://flagcdn.com/w${size}/${country}.png`;
}

export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_CODES = LANGUAGES.map(l => l.code);

export function getLanguage(code) {
  if (!code) return LANGUAGES[0];
  // Exact match first (e.g. 'pt-BR'), then base-language match (e.g. 'pt' -> 'pt-BR',
  // 'zh' -> 'zh-CN') so a detected variant still resolves to a supported entry
  // instead of wrongly falling back to English.
  const exact = LANGUAGES.find(l => l.code === code);
  if (exact) return exact;
  const base = String(code).split('-')[0].toLowerCase();
  const byBase = LANGUAGES.find(l => l.code.split('-')[0].toLowerCase() === base);
  return byBase || LANGUAGES[0];
}
